// src/components/SitemapPage.js
import React from 'react';
import { Link } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import { useI18n } from '../i18n/I18nContext';
import { getMiscPageCopy } from '../i18n/miscPageCopy';
import '../style/Homepage.css';
import '../style/Sitemap.css';

const SitemapPage = () => {
  const { language } = useI18n();
  const copy = getMiscPageCopy(language).sitemap;

  return (
  <div>
    <Header />
    <main className="info-page sitemap-page">
      <section className="sitemap-hero">
        <p className="eyebrow">{copy.eyebrow}</p>
        <h1>{copy.title}</h1>
        <p>{copy.description}</p>
      </section>

      <section className="sitemap-grid" aria-label={copy.label}>
        {copy.groups.map(([groupTitle, links]) => (
          <article className="sitemap-group-card" key={groupTitle}>
            <h2>{groupTitle}</h2>
            <ul>
              {links.map(([label, path]) => (
                <li key={path}>
                  <Link to={path}>{label}</Link>
                  <span>{path}</span>
                </li>
              ))}
            </ul>
          </article>
        ))}
      </section>

      <section className="sitemap-note-card">
        <p className="eyebrow">{copy.dynamic}</p>
        <h2>{copy.dynamicTitle}</h2>
        <p>{copy.dynamicBody}</p>
      </section>
    </main>
    <Footer />
  </div>
  );
};

export default SitemapPage;
